import { Dialog, DialogContent } from '@neo/primitives/dialog'
import { useState } from 'react'
import type { FlowTypes } from 'v2/types'
import { DialogView } from '../config/trigger-node.config'
import { useFlowStore } from '../store'
import { ExternalAppsConfig } from './external-apps-trigger'
import { TriggerSelectionView } from './trigger-selection-view'

export const TriggerDialog = () => {
  const [currentView, setCurrentView] = useState<DialogView>(DialogView.Main)
  const [selectedExternalApp, setSelectedExternalApp] = useState<FlowTypes | null>(null)

  const showTriggerDialog = useFlowStore((state) => state.showTriggerDialog)
  const setShowTriggerDialog = useFlowStore((state) => state.setShowTriggerDialog)

  const handleExternalAppConfigClick = (appType: FlowTypes) => {
    setSelectedExternalApp(appType)
    setCurrentView(DialogView.ExternalAppConfig)
  }

  const handleBackToMain = () => {
    setCurrentView(DialogView.Main)
  }

  const handleDialogClose = () => {
    setShowTriggerDialog(false)
  }

  return (
    <Dialog
      data-testid="trigger-dialog"
      open={showTriggerDialog}
      onOpenChange={(open) => {
        if (open) {
          setCurrentView(DialogView.Main)
        }
        setShowTriggerDialog(open)
      }}
    >
      <DialogContent className="max-w-xl h-[520px] p-0 flex flex-col" showCloseButton={false}>
        {currentView === 'main' ? (
          <TriggerSelectionView onExternalAppConfigClick={handleExternalAppConfigClick} />
        ) : (
          selectedExternalApp && (
            <ExternalAppsConfig
              appType={selectedExternalApp}
              onBack={handleBackToMain}
              onClose={handleDialogClose}
            />
          )
        )}
      </DialogContent>
    </Dialog>
  )
}
